import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import PageError from '@zenbusiness/zui/PageError';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { NAME } from '#client/build-env';
import { ENABLE_PARTNER_DASHBOARD } from '#client/constants/experimentsFlags';
import { usePartnerEntity } from '#client/hooks/usePartnerEntity';
import { HomeGateway, PartnerHome } from '#client/pages';

function CustomerRouterInner() {
  const { isPartner, partner, loading } = usePartnerEntity();
  const isPartnerDashboardEnabled = useExperimentFlag(ENABLE_PARTNER_DASHBOARD, false);

  if (loading) return <PageLoading />;

  if (isPartner && isPartnerDashboardEnabled) {
    return <PartnerHome partner={partner} />;
  }

  return <HomeGateway />;
}

export default function CustomerRouter() {
  return (
    <ErrorBoundary fallback={<PageError />} id={`${NAME}/App/CustomerRouter`}>
      <CustomerRouterInner />
    </ErrorBoundary>
  );
}
